import ThirdPartyServiceTable from "../ThirdPartyServiceTable";
import ThirdPartyServiceModel from "../../../models/thirdparty/ThirdPartyServiceModel";
import {useTranslation} from "react-i18next";
import {TableLabelCell, TableLabelHeader} from "../../common/CustomTable/CustomTable";
import React from "react";

function VeritoneServiceTable(props) {
    return (
        <ThirdPartyServiceTable {...props} type={ThirdPartyServiceModel.Type.VERITONE}
            TableHeaders={VeritoneServiceTableHeaders} TableRowCells={VeritoneServiceTableRowCells}
        />
    )
}

function VeritoneServiceTableHeaders() {
    const {t} = useTranslation(['thirdPartyService']);
    return (
        <>
            <TableLabelHeader label={t('thirdPartyService:label.url')}/>
        </>
    )
}

function VeritoneServiceTableRowCells(props) {
    const {
        thirdPartyService
    } = props;

    return (
        <>
            <TableLabelCell label={thirdPartyService.url}/>
        </>
    )
}

export default VeritoneServiceTable;
